(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerSector', CustomerSector);

    CustomerSector.$inject = ['$resource', 'DateUtils'];

    function CustomerSector ($resource, DateUtils) {
        var resourceUrl =  'api/customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertLocalDateFromServer(data.startedAt);
                        data.endedAt = DateUtils.convertLocalDateFromServer(data.endedAt);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startedAt = DateUtils.convertLocalDateToServer(copy.startedAt);
                    copy.endedAt = DateUtils.convertLocalDateToServer(copy.endedAt);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startedAt = DateUtils.convertLocalDateToServer(copy.startedAt);
                    copy.endedAt = DateUtils.convertLocalDateToServer(copy.endedAt);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
